import { useEffect, useRef } from "react";
import LoadingPopup from "../components/popups/loading";
import SuccessPopup from "../components/popups/success";
import AddFunds from "../components/popups/addFunds";
import LinkBank from "../components/popups/linkBank";
import {
  getUserCustodyBanks,
  setUserCustodyBanks,
} from "../services/contracts/clientContract";
import useUserStore from "../store/userSlice";
import useNetworkStore from "../store/networkStore";
import { ethers } from "ethers";
import { errorToast, successToast } from "../utils/constants";
import { chainDetails, useWalletInApp } from "../utils/config";
import InAppWallet from "../components/popups/mobileWallet";
import { DownloadVerifiedWallet } from "../components/popups/network";
import { hashTheString } from "@verified-network/verified-custody";
import { randomBytes } from "@noble/hashes/utils";
import {
  moneyHubClientUserAccessToken,
  moneyHubCompletePayment,
  moneyHubConnectAccessToken,
  moneyHubPaymentToken,
  moneyHubUserAccounts,
} from "../utils/helpers/moneyhub";
import {
  arrayBufferToBase64,
  getAllVerifiedCashBalances,
  hexToBytes,
} from "../utils/helpers/utils";
import { blinkUserAccounts } from "../utils/helpers/blink";
import { getStripeAccountStatus } from "../utils/helpers/stripe";
import {
  checkOTPVerification,
  sendCoSignerInvitation,
  sendCreatorAcceptance,
  sendCreatorCompleted,
  sendCreatorConfirmation,
  sendCreatorInitiation,
  sendCreatorRejection,
  sendCreatorSigned,
  sendOTPVerification,
} from "../utils/helpers/verifiedCustody.js";
import {
  iniciadorConnectLink,
  iniciadorLinkDetails,
  iniciadorUserAccounts,
} from "../utils/helpers/iniciador/index.js";

export const useHandleBankAndWalletRedirections = (
  mobileScreen,
  setPopupContentPosition,
  setPopupContent,
  setFavouriteClicked,
  setShowPopup,
  setPageAction,
  generalDataProps,
  customLoading,
  setCustomLoading,
  setPageStep,
  verifiedWalletDetails,
  custodyWalletDetails,
) => {
  const hasRunRef = useRef(false);

  const { userAddress, userId } = useUserStore();

  const { chainId, provider, signer, web3 } = useNetworkStore();

  useEffect(() => {
    const handleMoneyHubRedirections = async () => {
      if (hasRunRef.current) return;
      const hashArray = window.location.hash.replace("#", "").split("&");
      if (hashArray.length === 3) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Authenticating..."
            customTextFooter="Generating access token to authenticate your bank connection."
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }

        setShowPopup(true);

        const codeArray = hashArray[0].split("=");
        const idTokenArray = hashArray[1].split("=");
        const userIdArray = hashArray[2].split("=");
        const code = codeArray[1];
        const id_token = idTokenArray[1];
        const user_id = userIdArray[1];

        if (user_id?.toLowerCase().startsWith("your")) {
          await moneyHubConnectAccessToken(code, id_token, user_id).then(
            async (res) => {
              if (res) {
                await moneyHubUserAccounts(res).then(async (_res) => {
                  if (_res) {
                    setTimeout(() => {
                      if (!mobileScreen) {
                        setPopupContent(
                          <SuccessPopup
                            setShowPopup={setShowPopup}
                            setPopupContent={setPopupContent}
                            setPopupContentPosition={setPopupContentPosition}
                            isCustom={true}
                            customTextHeader="Congratulations!"
                            customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                            setFavouriteClicked={setFavouriteClicked}
                            showButton={true}
                            buttonText="Go to payments"
                            buttonFunc={() => {
                              setPopupContent(
                                <AddFunds
                                  setShowPopup={setShowPopup}
                                  setPopupContent={setPopupContent}
                                  setPopupContentPosition={
                                    setPopupContentPosition
                                  }
                                  customLoading={customLoading}
                                  setCustomLoading={setCustomLoading}
                                  generalDataProps={generalDataProps}
                                  addFundsAction="add-funds"
                                />,
                              );
                              setPopupContentPosition("flex-end");
                              setShowPopup(true);
                            }}
                          />,
                        );
                        setPopupContentPosition("flex-end");
                        setShowPopup(true);
                      } else {
                        setPageAction("Authentication");
                        setPopupContent(
                          <SuccessPopup
                            setShowPopup={setShowPopup}
                            setPopupContent={setPopupContent}
                            setPopupContentPosition={setPopupContentPosition}
                            isCustom={true}
                            customTextHeader="Congratulations!"
                            customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                            setFavouriteClicked={setFavouriteClicked}
                            showButton={true}
                            mobileScreen={mobileScreen}
                          />,
                        );
                        setPopupContentPosition("center");
                        setShowPopup(true);
                      }
                    }, 2000);
                  } else {
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  }
                });
              } else {
                setTimeout(() => {
                  if (!mobileScreen) {
                    setPopupContent(
                      <LinkBank
                        setShowPopup={setShowPopup}
                        setPopupContent={setPopupContent}
                        setPopupContentPosition={setPopupContentPosition}
                        currentStep="2"
                        generalDataProps={generalDataProps}
                        countryList={[]}
                        buttonAction="link-bank"
                      />,
                    );
                    setPopupContentPosition("flex-end");
                    setShowPopup(true);
                  } else {
                    setPageStep("2");
                    setPageAction("link-bank");
                    window.location.href = `${window.location.origin}/link-bank-option`;
                  }
                });
              }
            },
          );
        } else {
          await moneyHubConnectAccessToken(code, id_token, user_id).then(
            async (authTk) => {
              if (authTk) {
                await moneyHubClientUserAccessToken(user_id).then(
                  async (res) => {
                    if (res) {
                      await moneyHubUserAccounts(res).then(async (_res) => {
                        if (_res && _res.length > 0) {
                          await getUserCustodyBanks(
                            chainId,
                            userAddress,
                            signer,
                          ).then(async (cus) => {
                            if (cus) {
                              if (
                                cus.length > 0 &&
                                cus?.find(
                                  (bnk) =>
                                    ethers.utils
                                      .parseBytes32String(bnk?.currency)
                                      ?.toLowerCase() ===
                                    "MONEYHUB"?.toLowerCase(),
                                )
                              ) {
                                if (!mobileScreen) {
                                  setPopupContent(
                                    <SuccessPopup
                                      setShowPopup={setShowPopup}
                                      setPopupContent={setPopupContent}
                                      setPopupContentPosition={
                                        setPopupContentPosition
                                      }
                                      isCustom={true}
                                      customTextHeader="Congratulations!"
                                      customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                      setFavouriteClicked={setFavouriteClicked}
                                      showButton={true}
                                      buttonText="Go to payments"
                                      buttonFunc={() => {
                                        setPopupContent(
                                          <AddFunds
                                            setShowPopup={setShowPopup}
                                            setPopupContent={setPopupContent}
                                            setPopupContentPosition={
                                              setPopupContentPosition
                                            }
                                            customLoading={customLoading}
                                            setCustomLoading={setCustomLoading}
                                            generalDataProps={generalDataProps}
                                            addFundsAction="add-funds"
                                          />,
                                        );
                                        setPopupContentPosition("flex-end");
                                        setShowPopup(true);
                                      }}
                                    />,
                                  );
                                  setPopupContentPosition("flex-end");
                                  setShowPopup(true);
                                } else {
                                  setPageAction("Authentication");
                                  setPopupContent(
                                    <SuccessPopup
                                      setShowPopup={setShowPopup}
                                      setPopupContent={setPopupContent}
                                      setPopupContentPosition={
                                        setPopupContentPosition
                                      }
                                      isCustom={true}
                                      customTextHeader="Congratulations!"
                                      customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                      setFavouriteClicked={setFavouriteClicked}
                                      showButton={true}
                                      mobileScreen={mobileScreen}
                                    />,
                                  );
                                  setPopupContentPosition("center");
                                  setShowPopup(true);
                                }
                              } else {
                                setPopupContent(
                                  <LoadingPopup
                                    setShowPopup={setShowPopup}
                                    setPopupContent={setPopupContent}
                                    setPopupContentPosition={
                                      setPopupContentPosition
                                    }
                                    setFavouriteClicked={setFavouriteClicked}
                                    action=""
                                    isCustom={true}
                                    customTextHeader="Finalizing..."
                                    customTextFooter="Approve transaction to save and link new bank account(s) details to your wallet."
                                    generalDataProps={generalDataProps}
                                    mobileScreen={mobileScreen}
                                  />,
                                );
                                if (mobileScreen) {
                                  setPopupContentPosition("center");
                                } else {
                                  setPopupContentPosition("flex-end");
                                }
                                setShowPopup(true);
                                let paymentToken;
                                if (
                                  verifiedWalletDetails &&
                                  Object?.keys(verifiedWalletDetails)?.length >
                                    0 &&
                                  chainId &&
                                  web3 &&
                                  userAddress
                                ) {
                                  const cashTokens =
                                    await getAllVerifiedCashBalances(
                                      chainId,
                                      web3,
                                      userAddress,
                                    );

                                  paymentToken = cashTokens[0];
                                }
                                await setUserCustodyBanks(
                                  chainId,
                                  userAddress,
                                  signer,
                                  "MONEYHUB",
                                  user_id,
                                  paymentToken,
                                  provider,
                                  web3,
                                  custodyWalletDetails,
                                ).then((hash) => {
                                  if (hash) {
                                    custodyWalletDetails?.custodyId?.length > 0
                                      ? successToast(
                                          "Transaction Successful!",
                                          "Set user bank successfully.",
                                        )
                                      : successToast(
                                          "Transaction Successful!",
                                          "Set user bank successfully.",
                                          hash,
                                        );
                                    if (!mobileScreen) {
                                      setPopupContent(
                                        <SuccessPopup
                                          setShowPopup={setShowPopup}
                                          setPopupContent={setPopupContent}
                                          setPopupContentPosition={
                                            setPopupContentPosition
                                          }
                                          isCustom={true}
                                          customTextHeader="Congratulations!"
                                          customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                          setFavouriteClicked={
                                            setFavouriteClicked
                                          }
                                          showButton={true}
                                          buttonText="Go to payments"
                                          buttonFunc={() => {
                                            setPopupContent(
                                              <AddFunds
                                                setShowPopup={setShowPopup}
                                                setPopupContent={
                                                  setPopupContent
                                                }
                                                setPopupContentPosition={
                                                  setPopupContentPosition
                                                }
                                                customLoading={customLoading}
                                                setCustomLoading={
                                                  setCustomLoading
                                                }
                                                generalDataProps={
                                                  generalDataProps
                                                }
                                                addFundsAction="add-funds"
                                              />,
                                            );
                                            setPopupContentPosition("flex-end");
                                            setShowPopup(true);
                                          }}
                                        />,
                                      );
                                      setPopupContentPosition("flex-end");
                                      setShowPopup(true);
                                    } else {
                                      setPageAction("Authentication");
                                      setPopupContent(
                                        <SuccessPopup
                                          setShowPopup={setShowPopup}
                                          setPopupContent={setPopupContent}
                                          setPopupContentPosition={
                                            setPopupContentPosition
                                          }
                                          isCustom={true}
                                          customTextHeader="Congratulations!"
                                          customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                          setFavouriteClicked={
                                            setFavouriteClicked
                                          }
                                          showButton={true}
                                          mobileScreen={mobileScreen}
                                        />,
                                      );
                                      setPopupContentPosition("center");
                                      setShowPopup(true);
                                    }
                                  } else {
                                    errorToast(
                                      "Oops Something went wrong",
                                      "Error while setting user bank. Try again later.",
                                    );
                                    if (!mobileScreen) {
                                      setPopupContent(
                                        <LinkBank
                                          setShowPopup={setShowPopup}
                                          setPopupContent={setPopupContent}
                                          setPopupContentPosition={
                                            setPopupContentPosition
                                          }
                                          currentStep="2"
                                          generalDataProps={generalDataProps}
                                          countryList={[]}
                                          buttonAction="link-bank"
                                        />,
                                      );
                                      setPopupContentPosition("flex-end");
                                      setShowPopup(true);
                                    } else {
                                      setPageStep("2");
                                      setPageAction("link-bank");
                                      window.location.href = `${window.location.origin}/link-bank-option`;
                                    }
                                  }
                                });
                              }
                            } else {
                              errorToast(
                                "Invalid Bank Account",
                                "The connected account has 0 bank(s). connect a valid bank account",
                              );
                              if (!mobileScreen) {
                                setPopupContent(
                                  <LinkBank
                                    setShowPopup={setShowPopup}
                                    setPopupContent={setPopupContent}
                                    setPopupContentPosition={
                                      setPopupContentPosition
                                    }
                                    currentStep="2"
                                    generalDataProps={generalDataProps}
                                    countryList={[]}
                                    buttonAction="link-bank"
                                  />,
                                );
                                setPopupContentPosition("flex-end");
                                setShowPopup(true);
                              } else {
                                setPageStep("2");
                                setPageAction("link-bank");
                                window.location.href = `${window.location.origin}/link-bank-option`;
                              }
                            }
                          });
                        } else if (_res && _res.length === 0) {
                          errorToast(
                            "Invalid Bank Account",
                            "The connected account has 0 bank(s). connect a valid bank account",
                          );
                          if (!mobileScreen) {
                            setPopupContent(
                              <LinkBank
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                currentStep="2"
                                generalDataProps={generalDataProps}
                                countryList={[]}
                                buttonAction="link-bank"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          } else {
                            setPageStep("2");
                            setPageAction("link-bank");
                            window.location.href = `${window.location.origin}/link-bank-option`;
                          }
                        } else {
                          errorToast(
                            "Invalid Bank Account",
                            "The connected account has 0 bank(s). connect a valid bank account",
                          );
                          if (!mobileScreen) {
                            setPopupContent(
                              <LinkBank
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                currentStep="2"
                                generalDataProps={generalDataProps}
                                countryList={[]}
                                buttonAction="link-bank"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          } else {
                            setPageStep("2");
                            setPageAction("link-bank");
                            window.location.href = `${window.location.origin}/link-bank-option`;
                          }
                        }
                      });
                    } else {
                      errorToast(
                        "Oops Something went wrong",
                        "Error while authenticating bank connection. Try again  later",
                      );
                      setTimeout(() => {
                        if (!mobileScreen) {
                          setPopupContent(
                            <LinkBank
                              setShowPopup={setShowPopup}
                              setPopupContent={setPopupContent}
                              setPopupContentPosition={setPopupContentPosition}
                              currentStep="2"
                              generalDataProps={generalDataProps}
                              countryList={[]}
                              buttonAction="link-bank"
                            />,
                          );
                          setPopupContentPosition("flex-end");
                          setShowPopup(true);
                        } else {
                          setPageStep("2");
                          setPageAction("link-bank");
                          window.location.href = `${window.location.origin}/link-bank-option`;
                        }
                      });
                    }
                  },
                );
              } else {
                errorToast(
                  "Oops Something went wrong",
                  "Error while authenticating bank connection. Try again  later",
                );
                setTimeout(() => {
                  if (!mobileScreen) {
                    setPopupContent(
                      <LinkBank
                        setShowPopup={setShowPopup}
                        setPopupContent={setPopupContent}
                        setPopupContentPosition={setPopupContentPosition}
                        currentStep="2"
                        generalDataProps={generalDataProps}
                        countryList={[]}
                        buttonAction="link-bank"
                      />,
                    );
                    setPopupContentPosition("flex-end");
                    setShowPopup(true);
                  } else {
                    setPageStep("2");
                    setPageAction("link-bank");
                    window.location.href = `${window.location.origin}/link-bank-option`;
                  }
                });
              }
            },
          );
        }
      }
    };

    const handleBlinkRedirections = async () => {
      if (hasRunRef.current) return;
      if (
        window.location.search?.replace("?", "")?.split("=")?.length === 2 &&
        window.location.search?.replace("?", "")?.split("=")[0] ===
          "provider_id" &&
        window.location.search?.replace("?", "")?.split("=")[1]?.length > 0
      ) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Authenticating..."
            customTextFooter="Generating access token to authenticate your bank connection."
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);

        const providerId = window.location.search
          ?.replace("?", "")
          ?.split("=")[1];

        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (cus) => {
            if (cus) {
              if (
                cus.length > 0 &&
                cus?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (cus?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);
                await blinkUserAccounts(userId, providerId).then((_res) => {
                  if (_res && _res?.length > 0) {
                    if (!mobileScreen) {
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          buttonText="Go to payments"
                          buttonFunc={() => {
                            setPopupContent(
                              <AddFunds
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                customLoading={customLoading}
                                setCustomLoading={setCustomLoading}
                                generalDataProps={generalDataProps}
                                addFundsAction="add-funds"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          }}
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageAction("Authentication");
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          mobileScreen={mobileScreen}
                        />,
                      );
                      setPopupContentPosition("center");
                      setShowPopup(true);
                    }
                  } else if (_res && _res?.length === 0) {
                    errorToast(
                      "Oops Something went wrong",
                      "The connected account has 0 bank(s). connect a valid bank account",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while authenticating bank connection. Try again  later",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  }
                });
              } else {
                const newId =
                  userId +
                  userAddress.slice(
                    userAddress?.length - 8,
                    userAddress?.length,
                  );
                await blinkUserAccounts(newId?.slice(0, 31), providerId).then(
                  async (_res) => {
                    if (_res && _res?.length > 0) {
                      setPopupContent(
                        <LoadingPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          setFavouriteClicked={setFavouriteClicked}
                          action=""
                          isCustom={true}
                          customTextHeader="Finalizing..."
                          customTextFooter="Approve transaction to save and link new bank account(s) details to your wallet."
                          generalDataProps={generalDataProps}
                          mobileScreen={mobileScreen}
                        />,
                      );
                      if (mobileScreen) {
                        setPopupContentPosition("center");
                      } else {
                        setPopupContentPosition("flex-end");
                      }
                      setShowPopup(true);
                      let paymentToken;
                      if (
                        verifiedWalletDetails &&
                        Object?.keys(verifiedWalletDetails)?.length > 0 &&
                        chainId &&
                        web3 &&
                        userAddress
                      ) {
                        const cashTokens = await getAllVerifiedCashBalances(
                          chainId,
                          web3,
                          userAddress,
                        );

                        paymentToken = cashTokens[0];
                      }
                      await setUserCustodyBanks(
                        chainId,
                        userAddress,
                        signer,
                        "BLINK",
                        newId?.slice(0, 31),
                        paymentToken,
                        provider,
                        web3,
                        custodyWalletDetails,
                      ).then((hash) => {
                        if (hash) {
                          custodyWalletDetails?.custodyId?.length > 0
                            ? successToast(
                                "Transaction Successful!",
                                "Set user bank successfully.",
                              )
                            : successToast(
                                "Transaction Successful!",
                                "Set user bank successfully.",
                                hash,
                              );
                          if (!mobileScreen) {
                            setPopupContent(
                              <SuccessPopup
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                isCustom={true}
                                customTextHeader="Congratulations!"
                                customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                setFavouriteClicked={setFavouriteClicked}
                                showButton={true}
                                buttonText="Go to payments"
                                buttonFunc={() => {
                                  setPopupContent(
                                    <AddFunds
                                      setShowPopup={setShowPopup}
                                      setPopupContent={setPopupContent}
                                      setPopupContentPosition={
                                        setPopupContentPosition
                                      }
                                      customLoading={customLoading}
                                      setCustomLoading={setCustomLoading}
                                      generalDataProps={generalDataProps}
                                      addFundsAction="add-funds"
                                    />,
                                  );
                                  setPopupContentPosition("flex-end");
                                  setShowPopup(true);
                                }}
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          } else {
                            setPageAction("Authentication");
                            setPopupContent(
                              <SuccessPopup
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                isCustom={true}
                                customTextHeader="Congratulations!"
                                customTextFooter={`You have successfully linked ${_res.length} bank accounts`}
                                setFavouriteClicked={setFavouriteClicked}
                                showButton={true}
                                mobileScreen={mobileScreen}
                              />,
                            );
                            setPopupContentPosition("center");
                            setShowPopup(true);
                          }
                        } else {
                          errorToast(
                            "Oops Something went wrong",
                            "Error while setting user bank. Try again later.",
                          );
                          if (!mobileScreen) {
                            setPopupContent(
                              <LinkBank
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                currentStep="2"
                                generalDataProps={generalDataProps}
                                countryList={[]}
                                buttonAction="link-bank"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          } else {
                            setPageStep("2");
                            setPageAction("link-bank");
                            window.location.href = `${window.location.origin}/link-bank-option`;
                          }
                        }
                      });
                    } else if (_res && _res?.length === 0) {
                      errorToast(
                        "Invalid Bank Account",
                        "The connected account has 0 bank(s). connect a valid bank account",
                      );
                      if (!mobileScreen) {
                        setPopupContent(
                          <LinkBank
                            setShowPopup={setShowPopup}
                            setPopupContent={setPopupContent}
                            setPopupContentPosition={setPopupContentPosition}
                            currentStep="2"
                            generalDataProps={generalDataProps}
                            countryList={[]}
                            buttonAction="link-bank"
                          />,
                        );
                        setPopupContentPosition("flex-end");
                        setShowPopup(true);
                      } else {
                        setPageStep("2");
                        setPageAction("link-bank");
                        window.location.href = `${window.location.origin}/link-bank-option`;
                      }
                    } else {
                      errorToast(
                        "Oops Something went wrong",
                        "Error while authenticating bank connection. Try again  later",
                      );
                      if (!mobileScreen) {
                        setPopupContent(
                          <LinkBank
                            setShowPopup={setShowPopup}
                            setPopupContent={setPopupContent}
                            setPopupContentPosition={setPopupContentPosition}
                            currentStep="2"
                            generalDataProps={generalDataProps}
                            countryList={[]}
                            buttonAction="link-bank"
                          />,
                        );
                        setPopupContentPosition("flex-end");
                        setShowPopup(true);
                      } else {
                        setPageStep("2");
                        setPageAction("link-bank");
                        window.location.href = `${window.location.origin}/link-bank-option`;
                      }
                    }
                  },
                );
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Error while authenticating bank connection. Try again later",
              );
              if (!mobileScreen) {
                setPopupContent(
                  <LinkBank
                    setShowPopup={setShowPopup}
                    setPopupContent={setPopupContent}
                    setPopupContentPosition={setPopupContentPosition}
                    currentStep="2"
                    generalDataProps={generalDataProps}
                    countryList={[]}
                    buttonAction="link-bank"
                  />,
                );
                setPopupContentPosition("flex-end");
                setShowPopup(true);
              } else {
                setPageStep("2");
                setPageAction("link-bank");
                window.location.href = `${window.location.origin}/link-bank-option`;
              }
            }
          },
        );
      }
    };

    const handleIniciadorRedirections = async () => {
      if (hasRunRef.current) return;

      if (
        window.location.hash.replace("#", "").split("&")?.length === 2 &&
        window.location.search.replace("?", "").split("&")?.length === 2
      ) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Authenticating..."
            customTextFooter="Generating access token to authenticate your bank connection."
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);

        const linkId = window.location.search
          .replace("?", "")
          .split("&")[0]
          ?.split("=")[1];

        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (cus) => {
            if (cus) {
              if (
                cus.length > 0 &&
                cus?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "INICIADOR"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (cus?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "INICIADOR"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);
                await iniciadorUserAccounts(userId).then((_res) => {
                  console.log("accounttt ressss: ", _res);
                  if (_res && _res?.data?.length > 0) {
                    if (!mobileScreen) {
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked ${_res?.data?.length} bank accounts`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          buttonText="Go to payments"
                          buttonFunc={() => {
                            setPopupContent(
                              <AddFunds
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                customLoading={customLoading}
                                setCustomLoading={setCustomLoading}
                                generalDataProps={generalDataProps}
                                addFundsAction="add-funds"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          }}
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageAction("Authentication");
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked ${_res?.data?.length} bank accounts`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          mobileScreen={mobileScreen}
                        />,
                      );
                      setPopupContentPosition("center");
                      setShowPopup(true);
                    }
                  } else if (_res && _res?.data?.length === 0) {
                    errorToast(
                      "Oops Something went wrong",
                      "The connected account has 0 bank(s). connect a valid bank account",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while authenticating bank connection. Try again  later",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  }
                });
              } else {
                const newId =
                  userId +
                  userAddress.slice(
                    userAddress?.length - 8,
                    userAddress?.length,
                  );
                await iniciadorLinkDetails(linkId).then(async (_res) => {
                  if (
                    _res &&
                    _res?.status === "AUTHORISED" &&
                    _res?.permissionsGranted?.includes("ACCOUNTS_ALL")
                  ) {
                    setPopupContent(
                      <LoadingPopup
                        setShowPopup={setShowPopup}
                        setPopupContent={setPopupContent}
                        setPopupContentPosition={setPopupContentPosition}
                        setFavouriteClicked={setFavouriteClicked}
                        action=""
                        isCustom={true}
                        customTextHeader="Finalizing..."
                        customTextFooter="Approve transaction to save and link new bank account(s) details to your wallet."
                        generalDataProps={generalDataProps}
                        mobileScreen={mobileScreen}
                      />,
                    );
                    if (mobileScreen) {
                      setPopupContentPosition("center");
                    } else {
                      setPopupContentPosition("flex-end");
                    }
                    setShowPopup(true);
                    let paymentToken;
                    if (
                      verifiedWalletDetails &&
                      Object?.keys(verifiedWalletDetails)?.length > 0 &&
                      chainId &&
                      web3 &&
                      userAddress
                    ) {
                      const cashTokens = await getAllVerifiedCashBalances(
                        chainId,
                        web3,
                        userAddress,
                      );

                      paymentToken = cashTokens[0];
                    }
                    await setUserCustodyBanks(
                      chainId,
                      userAddress,
                      signer,
                      "INICIADOR",
                      newId?.slice(0, 31),
                      paymentToken,
                      provider,
                      web3,
                      custodyWalletDetails,
                    ).then((hash) => {
                      if (hash) {
                        custodyWalletDetails?.custodyId?.length > 0
                          ? successToast(
                              "Transaction Successful!",
                              "Set user bank successfully.",
                            )
                          : successToast(
                              "Transaction Successful!",
                              "Set user bank successfully.",
                              hash,
                            );
                        if (!mobileScreen) {
                          setPopupContent(
                            <SuccessPopup
                              setShowPopup={setShowPopup}
                              setPopupContent={setPopupContent}
                              setPopupContentPosition={setPopupContentPosition}
                              isCustom={true}
                              customTextHeader="Congratulations!"
                              customTextFooter={`You have successfully linked bank account(s)`}
                              setFavouriteClicked={setFavouriteClicked}
                              showButton={true}
                              buttonText="Go to payments"
                              buttonFunc={() => {
                                setPopupContent(
                                  <AddFunds
                                    setShowPopup={setShowPopup}
                                    setPopupContent={setPopupContent}
                                    setPopupContentPosition={
                                      setPopupContentPosition
                                    }
                                    customLoading={customLoading}
                                    setCustomLoading={setCustomLoading}
                                    generalDataProps={generalDataProps}
                                    addFundsAction="add-funds"
                                  />,
                                );
                                setPopupContentPosition("flex-end");
                                setShowPopup(true);
                              }}
                            />,
                          );
                          setPopupContentPosition("flex-end");
                          setShowPopup(true);
                        } else {
                          setPageAction("Authentication");
                          setPopupContent(
                            <SuccessPopup
                              setShowPopup={setShowPopup}
                              setPopupContent={setPopupContent}
                              setPopupContentPosition={setPopupContentPosition}
                              isCustom={true}
                              customTextHeader="Congratulations!"
                              customTextFooter={`You have successfully linked bank account(s)`}
                              setFavouriteClicked={setFavouriteClicked}
                              showButton={true}
                              mobileScreen={mobileScreen}
                            />,
                          );
                          setPopupContentPosition("center");
                          setShowPopup(true);
                        }
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Error while setting user bank. Try again later.",
                        );
                        if (!mobileScreen) {
                          setPopupContent(
                            <LinkBank
                              setShowPopup={setShowPopup}
                              setPopupContent={setPopupContent}
                              setPopupContentPosition={setPopupContentPosition}
                              currentStep="2"
                              generalDataProps={generalDataProps}
                              countryList={[]}
                              buttonAction="link-bank"
                            />,
                          );
                          setPopupContentPosition("flex-end");
                          setShowPopup(true);
                        } else {
                          setPageStep("2");
                          setPageAction("link-bank");
                          window.location.href = `${window.location.origin}/link-bank-option`;
                        }
                      }
                    });
                  } else if (
                    _res &&
                    _res?.status === "AUTHORISED" &&
                    !_res?.permissionsGranted?.includes("ACCOUNTS_ALL")
                  ) {
                    errorToast(
                      "Incompleted bank permissions",
                      "Connect bank again and select at least Accounts permission",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  } else if (_res && _res?.status !== "AUTHORISED") {
                    errorToast(
                      "Bank connection not authorized",
                      "Incomplete bank link. Try again later.",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while authenticating bank connection. Try again  later",
                    );
                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-bank"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-bank");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Error while authenticating bank connection. Try again later",
              );
              if (!mobileScreen) {
                setPopupContent(
                  <LinkBank
                    setShowPopup={setShowPopup}
                    setPopupContent={setPopupContent}
                    setPopupContentPosition={setPopupContentPosition}
                    currentStep="2"
                    generalDataProps={generalDataProps}
                    countryList={[]}
                    buttonAction="link-bank"
                  />,
                );
                setPopupContentPosition("flex-end");
                setShowPopup(true);
              } else {
                setPageStep("2");
                setPageAction("link-bank");
                window.location.href = `${window.location.origin}/link-bank-option`;
              }
            }
          },
        );
      }
    };

    const handleStripeRedirections = async () => {
      if (hasRunRef.current) return;
      const hashArray = window.location.hash.replace("#", "").split("&");
      if (hashArray.length === 4) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Finalizing..."
            customTextFooter="Approve transaction to save and link new card account details to your wallet."
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);

        const actionArray = hashArray[0].split("=");
        const countryArray = hashArray[1].split("=");
        const account_idArray = hashArray[2].split("=");
        const bank_typeArray = hashArray[3].split("=");
        const action = actionArray[1];
        const country = countryArray[1];
        const countryCode = countryArray[1]?.split("-")[0];
        const account_id = account_idArray[1];
        const bank_type = bank_typeArray[1];

        if (
          bank_type === "stripe" &&
          action === "set-user-custody-bank" &&
          countryCode
        ) {
          await getStripeAccountStatus(account_id, countryCode, chainId).then(
            async (isKyced) => {
              if (isKyced) {
                let paymentToken;
                if (
                  verifiedWalletDetails &&
                  Object?.keys(verifiedWalletDetails)?.length > 0 &&
                  chainId &&
                  web3 &&
                  userAddress
                ) {
                  const cashTokens = await getAllVerifiedCashBalances(
                    chainId,
                    web3,
                    userAddress,
                  );

                  paymentToken = cashTokens[0];
                }
                await setUserCustodyBanks(
                  chainId,
                  userAddress,
                  signer,
                  country,
                  account_id,
                  paymentToken,
                  provider,
                  web3,
                  custodyWalletDetails,
                ).then((res) => {
                  if (res) {
                    custodyWalletDetails?.custodyId?.length > 0
                      ? successToast(
                          "Transaction Successful!",
                          "Set user bank successfully.",
                        )
                      : successToast(
                          "Transaction Successful!",
                          "Set user bank successfully.",
                          res,
                        );

                    if (!mobileScreen) {
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked your Stripe account in ${country}`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          buttonText="Go to payments"
                          buttonFunc={() => {
                            setPopupContent(
                              <AddFunds
                                setShowPopup={setShowPopup}
                                setPopupContent={setPopupContent}
                                setPopupContentPosition={
                                  setPopupContentPosition
                                }
                                customLoading={customLoading}
                                setCustomLoading={setCustomLoading}
                                generalDataProps={generalDataProps}
                                addFundsAction="add-funds"
                              />,
                            );
                            setPopupContentPosition("flex-end");
                            setShowPopup(true);
                          }}
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageAction("Authentication");
                      setPopupContent(
                        <SuccessPopup
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully linked your Stripe account in ${country}`}
                          setFavouriteClicked={setFavouriteClicked}
                          showButton={true}
                          mobileScreen={mobileScreen}
                        />,
                      );
                      setPopupContentPosition("center");
                      setShowPopup(true);
                    }
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while setting user bank. Try again later.",
                    );

                    if (!mobileScreen) {
                      setPopupContent(
                        <LinkBank
                          setShowPopup={setShowPopup}
                          setPopupContent={setPopupContent}
                          setPopupContentPosition={setPopupContentPosition}
                          currentStep="2"
                          generalDataProps={generalDataProps}
                          countryList={[]}
                          buttonAction="link-card"
                        />,
                      );
                      setPopupContentPosition("flex-end");
                      setShowPopup(true);
                    } else {
                      setPageStep("2");
                      setPageAction("link-card");
                      window.location.href = `${window.location.origin}/link-bank-option`;
                    }
                  }
                });
              } else {
                errorToast(
                  "Stripe Account not KYCed or incomplete on-boarding",
                  "Complete Stripe account onboarding/KYC and try again.",
                );

                if (!mobileScreen) {
                  setPopupContent(
                    <LinkBank
                      setShowPopup={setShowPopup}
                      setPopupContent={setPopupContent}
                      setPopupContentPosition={setPopupContentPosition}
                      currentStep="2"
                      generalDataProps={generalDataProps}
                      countryList={[]}
                      buttonAction="link-card"
                    />,
                  );
                  setPopupContentPosition("flex-end");
                  setShowPopup(true);
                } else {
                  setPageStep("2");
                  setPageAction("link-card");
                  window.location.href = `${window.location.origin}/link-bank-option`;
                }
              }
            },
          );
        }
      }
    };

    const handleCardPaymentRedirection = async () => {
      if (hasRunRef.current) return;
      const searchParams = window.location.search.replace("?", "").split("&");

      const redirectUrlArray = searchParams[2]?.split("=");
      const redirectUrl = redirectUrlArray[1];
      const currencySymbolRaw = window.location.hash
        .replace("#", "")
        ?.split("&")[1];
      const currencySymbol = currencySymbolRaw.split("=")[1];

      if (redirectUrl?.toLowerCase() === "succeeded") {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <SuccessPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            isCustom={true}
            customTextHeader="Payment Successfull!"
            customTextFooter={`Our Custodian will review your payment and top up equivalent ${currencySymbol?.toUpperCase()}`}
            setFavouriteClicked={setFavouriteClicked}
            showButton={true}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);
      } else if (redirectUrl?.toLowerCase() !== "succeeded") {
        errorToast(
          "Oops Something went wrong",
          "Payment incomplete. Try again later.",
        );
      }
    };

    const handleMoneyHubPaymentRedirection = async () => {
      if (hasRunRef.current) return;
      const searchArray = window.location.search?.replace("?", "")?.split("&");
      if (searchArray?.length === 3) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Authenticating..."
            customTextFooter="Generating access token to authenticate your payment request"
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);

        const stateArray = searchArray[0]?.split("=");
        const codeArray = searchArray[1]?.split("=");
        const idTokenArray = searchArray[2]?.split("=");
        const paymentIdArray = stateArray[1]?.split("__");

        await moneyHubPaymentToken(
          codeArray[1],
          idTokenArray[1],
          stateArray[1],
        ).then(async (res) => {
          if (res) {
            await moneyHubCompletePayment(
              res,
              codeArray[1],
              idTokenArray[1],
              stateArray[1],
              paymentIdArray[1],
            ).then(async (_res) => {
              if (_res?.data) {
                setPopupContent(
                  <SuccessPopup
                    setShowPopup={setShowPopup}
                    setPopupContent={setPopupContent}
                    setPopupContentPosition={setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Payment Successfull!"
                    customTextFooter={`Our Custodian will review your payment and top up equivalent cash tokens`}
                    setFavouriteClicked={setFavouriteClicked}
                    showButton={true}
                    mobileScreen={mobileScreen}
                  />,
                );
                if (mobileScreen) {
                  setPopupContentPosition("center");
                } else {
                  setPopupContentPosition("flex-end");
                }
                setShowPopup(true);
              } else {
                errorToast(
                  "Oops Something went wrong",
                  "Payment incomplete. Try again later.",
                );
                if (!mobileScreen) {
                  setPopupContent(
                    <AddFunds
                      setShowPopup={setShowPopup}
                      setPopupContent={setPopupContent}
                      setPopupContentPosition={setPopupContentPosition}
                      setFavouriteClicked={setFavouriteClicked}
                      generalDataProps={generalDataProps}
                      addFundsAction="add-funds"
                    />,
                  );
                  setPopupContentPosition("flex-end");
                  setShowPopup(true);
                } else {
                  window.location.href = `${window.location.origin}/add-funds-method`;
                }
              }
            });
          } else {
          }
        });
      }
    };

    const handleWalletRedirections = async () => {
      if (hasRunRef.current) return;
      const searchArray = window.location.search?.replace("?", "")?.split("&");
      if (
        window.location.pathname === "/accp-inv" &&
        searchArray?.length === 3
      ) {
        hasRunRef.current = true;
        const vId = searchArray[0]?.split("=")[1];
        const cId = searchArray[1]?.split("=")[1];
        const vPh = searchArray[2]?.split("=")[1];

        if (vId && cId && vPh) {
          if (window?.verifiedwallet?.request) {
            setShowPopup(true);
            setCustomLoading(true);
            try {
              await window.verifiedwallet
                .request({
                  method: "invitation",
                  params: {
                    vaultData: { vId, vPh, cId },
                    chainId:
                      chainDetails[0].verifiedWalletChainId ||
                      chainDetails[0].chainId,
                  },
                })
                .then((res) => {
                  setShowPopup(false);
                  setCustomLoading(false);
                });
            } catch (err) {
              setShowPopup(false);
              setCustomLoading(false);
            }
          } else if (mobileScreen || useWalletInApp) {
            setPageAction("walletConnect");
            setPopupContentPosition("center");
            setPopupContent(
              <InAppWallet
                action="invitation"
                origin={window.location.host}
                title={"Verified Network"}
                reqVaultData={{
                  vId,

                  vPh,
                  cId,
                }}
                helperFunctions={{
                  sendCoSignerInvitation: sendCoSignerInvitation,
                  sendCreatorConfirmation: sendCreatorConfirmation,
                  sendCreatorInitiation: sendCreatorInitiation,
                  sendCreatorSigned: sendCreatorSigned,
                  sendCreatorCompleted: sendCreatorCompleted,
                  sendCreatorAcceptance: sendCreatorAcceptance,
                  sendCreatorRejection: sendCreatorRejection,
                  sendOTPVerification: sendOTPVerification,
                  checkOTPVerification: checkOTPVerification,
                }}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
                chainId={
                  chainDetails[0].verifiedWalletChainId ||
                  chainDetails[0].chainId
                }
              />,
            );

            setShowPopup(true);
          } else {
            setPopupContent(
              <DownloadVerifiedWallet
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                setPopupContentPosition={setPopupContentPosition}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
                generalDataProps={generalDataProps}
              />,
            );
            setPopupContentPosition("center");
            setShowPopup(true);
          }
        }
      } else if (
        window.location.pathname === "/sign-rec" &&
        searchArray?.length === 3
      ) {
        hasRunRef.current = true;
        const vId = searchArray[0]?.split("=")[1];
        const tId = searchArray[1]?.split("=")[1];
        const vPh = searchArray[2]?.split("=")[1];
        if (vId && tId && vPh) {
          if (window?.verifiedwallet?.request) {
            setShowPopup(true);
            setCustomLoading(true);
            try {
              await window.verifiedwallet
                .request({
                  method: "signRecovery",
                  params: {
                    vaultData: { vId, vPh },
                    txData: { id: tId },
                    chainId:
                      chainDetails[0].verifiedWalletChainId ||
                      chainDetails[0].chainId,
                  },
                })
                .then((res) => {
                  setShowPopup(false);
                  setCustomLoading(false);
                });
            } catch (err) {
              setShowPopup(false);
              setCustomLoading(false);
            }
          } else if (mobileScreen || useWalletInApp) {
            setPageAction("walletConnect");
            setPopupContentPosition("center");
            setPopupContent(
              <InAppWallet
                action="signRecovery"
                origin={window.location.host}
                title={"Verified Network"}
                chainId={
                  chainDetails[0].verifiedWalletChainId ||
                  chainDetails[0].chainId
                }
                reqVaultData={{ vId, vPh }}
                txData={{ id: tId }}
                helperFunctions={{
                  sendCoSignerInvitation: sendCoSignerInvitation,
                  sendCreatorConfirmation: sendCreatorConfirmation,
                  sendCreatorInitiation: sendCreatorInitiation,
                  sendCreatorSigned: sendCreatorSigned,
                  sendCreatorCompleted: sendCreatorCompleted,
                  sendCreatorAcceptance: sendCreatorAcceptance,
                  sendCreatorRejection: sendCreatorRejection,
                  sendOTPVerification: sendOTPVerification,
                  checkOTPVerification: checkOTPVerification,
                }}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
              />,
            );

            setShowPopup(true);
          } else {
            setPopupContent(
              <DownloadVerifiedWallet
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                setPopupContentPosition={setPopupContentPosition}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
                generalDataProps={generalDataProps}
              />,
            );
            setPopupContentPosition("center");
            setShowPopup(true);
          }
        }
      } else if (
        window.location.pathname === "/acc-rec" &&
        searchArray?.length === 2
      ) {
        hasRunRef.current = true;
        const vId = searchArray[0]?.split("=")[1];
        const tId = searchArray[1]?.split("=")[1];
        if (vId && tId) {
          if (window?.verifiedwallet?.request) {
            setShowPopup(true);
            setCustomLoading(true);
            try {
              await window.verifiedwallet
                .request({
                  method: "completeRecovery",
                  params: {
                    vaultData: { vId },
                    txData: { id: tId },
                    chainId:
                      chainDetails[0].verifiedWalletChainId ||
                      chainDetails[0].chainId,
                  },
                })
                .then((res) => {
                  setShowPopup(false);
                  setCustomLoading(false);
                });
            } catch (err) {
              setShowPopup(false);
              setCustomLoading(false);
            }
          } else if (mobileScreen || useWalletInApp) {
            setPageAction("walletConnect");
            setPopupContentPosition("center");
            setPopupContent(
              <InAppWallet
                action="completeRecovery"
                origin={window.location.host}
                title={"Verified Network"}
                reqVaultData={{ vId }}
                txData={{ id: tId }}
                helperFunctions={{
                  sendCoSignerInvitation: sendCoSignerInvitation,
                  sendCreatorConfirmation: sendCreatorConfirmation,
                  sendCreatorInitiation: sendCreatorInitiation,
                  sendCreatorSigned: sendCreatorSigned,
                  sendCreatorCompleted: sendCreatorCompleted,
                  sendCreatorAcceptance: sendCreatorAcceptance,
                  sendCreatorRejection: sendCreatorRejection,
                  sendOTPVerification: sendOTPVerification,
                  checkOTPVerification: checkOTPVerification,
                }}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
                chainId={
                  chainDetails[0].verifiedWalletChainId ||
                  chainDetails[0].chainId
                }
              />,
            );

            setShowPopup(true);
          } else {
            setPopupContent(
              <DownloadVerifiedWallet
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                setPopupContentPosition={setPopupContentPosition}
                mobileScreen={mobileScreen}
                verifiedWalletDetails={verifiedWalletDetails}
                generalDataProps={generalDataProps}
              />,
            );
            setPopupContentPosition("center");
            setShowPopup(true);
          }
        }
      }
    };

    const handlePasskeyRedirections = async () => {
      if (hasRunRef.current) return;
      const searchArray = window.location.search?.replace("?", "")?.split("&");
      if (
        window.location.pathname === "/create-passkey" &&
        searchArray?.length === 1
      ) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Creating New Passkey"
            customTextFooter={`Please follow the intrustions on the passkey popup to authentication creation.`}
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);
        const vId = searchArray[0]?.split("=")[1];
        if (vId) {
          const userId = hexToBytes(hashTheString(vId));
          const publicKeyCred = {
            challenge: randomBytes(32),
            rp: {
              name: "Verified Wallet",
            },
            user: {
              id: userId,
              name: vId,
              displayName: vId,
            },
            pubKeyCredParams: [
              { type: "public-key", alg: -7 }, // ES256
              { type: "public-key", alg: -257 }, // RS256
            ],
            authenticatorSelection: {
              userVerification: "preferred",
              residentKey: "required",
            },
            timeout: 60000,
            attestation: "none",
          };
          try {
            const credential = await navigator?.credentials?.create({
              publicKey: publicKeyCred,
            });
            if (credential) {
              window.postMessage(
                {
                  type: "VW:Passkey_Credential",
                  data: {
                    id: credential?.id,
                    rawId: arrayBufferToBase64(credential?.rawId),
                    action: "create",
                  },
                },
                "*",
              );
            } else {
              window.postMessage(
                {
                  type: "VW:Passkey_Credential",
                  data: { error: "unexpected error!", action: "create" },
                },
                "*",
              );
            }
          } catch (err) {}
        }
      }

      if (
        window.location.pathname === "/get-passkey" &&
        searchArray?.length === 1
      ) {
        hasRunRef.current = true;
        if (mobileScreen) {
          setPageAction("Authentication");
        }
        setPopupContent(
          <LoadingPopup
            setShowPopup={setShowPopup}
            setPopupContent={setPopupContent}
            setPopupContentPosition={setPopupContentPosition}
            setFavouriteClicked={setFavouriteClicked}
            action=""
            isCustom={true}
            customTextHeader="Fetching All Passkeys"
            customTextFooter={`Please follow the intrustions on the passkey popup to chose and authenticate any passkey of your choice.`}
            generalDataProps={generalDataProps}
            mobileScreen={mobileScreen}
          />,
        );
        if (mobileScreen) {
          setPopupContentPosition("center");
        } else {
          setPopupContentPosition("flex-end");
        }
        setShowPopup(true);
        const publicKeyCred = {
          challenge: randomBytes(32),
          timeout: 60000,
          userVerification: "preferred",
        };

        try {
          const credential = await navigator?.credentials?.get({
            publicKey: publicKeyCred,
          });
          if (credential) {
            window.postMessage(
              {
                type: "VW:Passkey_Credential",
                data: {
                  id: credential?.id,
                  rawId: arrayBufferToBase64(credential?.rawId),
                  action: "get",
                },
              },
              "*",
            );
          } else {
            window.postMessage(
              {
                type: "VW:Passkey_Credential",
                data: { error: "unexpected error!", action: "get" },
              },
              "*",
            );
          }
        } catch (err) {}
      }
    };

    if (
      window.location.hash &&
      window.location.hash.replace("#", "").split("&").length === 3 &&
      !window.location?.href?.includes("iniciador.com") &&
      userAddress &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleMoneyHubRedirections();
    }

    if (
      window.location.search &&
      window.location.search?.replace("?", "").startsWith("provider_id=") &&
      window.location.href?.includes("/blink/xe/") &&
      !window.location?.href?.includes("iniciador.com") &&
      userAddress &&
      userId &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleBlinkRedirections();
    }

    if (
      window.location.hash &&
      window.location.hash.replace("#", "").split("&")?.length === 2 &&
      window.location.hash.replace("#", "").split("&")[1]?.toLowerCase() ===
        "bank_type=iniciador" &&
      window.location.search.replace("?", "").split("&")?.length === 2 &&
      userAddress &&
      userId &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleIniciadorRedirections();
    }

    if (
      window.location.hash &&
      window.location.hash.replace("#", "").split("&").length === 4 &&
      !window.location?.href?.includes("iniciador.com") &&
      userAddress &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleStripeRedirections();
    }

    if (
      window.location.hash &&
      window.location.hash.replace("#", "")?.split("&")[0]?.toLowerCase() ===
        "card-payment" &&
      window.location.search &&
      window.location.search.replace("?", "").split("&").length === 3 &&
      !window.location?.href?.includes("iniciador.com") &&
      userAddress &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleCardPaymentRedirection();
    }

    if (
      window.location.search &&
      window.location.search?.replace("?", "").startsWith("state=") &&
      window.location.search?.includes("code=") &&
      window.location.search?.includes("id_token=") &&
      !window.location?.href?.includes("iniciador.com") &&
      userAddress &&
      chainId > 0 &&
      signer &&
      provider &&
      web3
    ) {
      handleMoneyHubPaymentRedirection();
    }

    if (
      window.location.search &&
      window.location.search?.replace("?", "").startsWith("v-id=")
    ) {
      handleWalletRedirections();
    }

    if (
      (window.location.search &&
        window.location.search?.replace("?", "").startsWith("id=")) ||
      (window.location.search === "" &&
        window.location.pathname === "/get-passkey")
    ) {
      handlePasskeyRedirections();
    }

    if (window.location.hash && window.location.hash.startsWith("#error")) {
      window.location.href = window.location.origin + "/errorPage";
    }
  }, [
    chainId,
    provider,
    web3,
    signer,
    userAddress,
    userId,
    mobileScreen,
    setPopupContent,
    setShowPopup,
    setPopupContentPosition,
    setFavouriteClicked,
    generalDataProps,
    setPageAction,
    customLoading,
    setCustomLoading,
    setPageStep,
    verifiedWalletDetails,
    custodyWalletDetails,
  ]);
};
